export default "__VITE_ASSET__BIhMWLoE__"